import { useEffect, useState } from "react";

export function useInView(ref, options) {
  const { root = null, rootMargin = "0px", threshold = 0 } = options || {};
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const obs = new IntersectionObserver(
      ([entry]) => setIsInView(entry.isIntersecting),
      { root, rootMargin, threshold }
    );

    obs.observe(el);
    return () => obs.disconnect();
  }, [ref, root, rootMargin, threshold]);

  return isInView;
}